import { useLanguage } from '../../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function LanguageSettings() {
  const { language, setLanguage, t } = useLanguage();

  const languages = [
    { id: 'english', name: 'English', flag: '🇺🇸' },
    { id: 'arabic', name: 'العربية', flag: '🇸🇦' },
    { id: 'kurdish', name: 'کوردی', flag: '🇮🇶' }
  ] as const;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="w-full px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Link to="/settings">
              <Button variant="outline" size="sm" className="border-slate-200 text-slate-700 hover:bg-slate-50 rounded-lg text-sm font-medium">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('settings.back')}
              </Button>
            </Link>
            <div>
              <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">{t('settings.language.title')}</h1>
              <p className="text-slate-500 text-sm mt-0.5">{t('settings.language.subtitle')}</p>
            </div>
          </div>
        </div>
      </header>

      <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
        <Card className="rounded-2xl border border-slate-200 shadow-sm">
          <CardHeader>
            <CardTitle>{t('settings.language.selectLanguage')}</CardTitle>
            <CardDescription>
              {t('settings.language.description')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {languages.map((lang) => (
                <Button
                  key={lang.id}
                  onClick={() => setLanguage(lang.id)}
                  variant={language === lang.id ? "default" : "outline"}
                  className={`w-full h-auto min-h-20 flex flex-col items-center justify-center space-y-2 p-4 !whitespace-normal ${
                    language === lang.id
                      ? 'bg-slate-900 hover:bg-slate-800 text-white'
                      : 'border-slate-200 hover:bg-slate-50'
                  }`}
                >
                  <span className="text-2xl">{lang.flag}</span>
                  <span className="font-medium text-sm text-center">{lang.name}</span>
                </Button>
              ))}
            </div>
            
            <div className="mt-6 p-4 bg-slate-50 rounded-lg border border-slate-100">
              <h3 className="font-medium text-slate-800 mb-2">{t('settings.language.currentLanguage')}</h3>
              <p className="text-slate-600">
                {languages.find(lang => lang.id === language)?.flag} {languages.find(lang => lang.id === language)?.name}
              </p>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
